import ListingVM from './listing-vm';

export default {
  init() {
    const sessionsData = JSON.parse(
      document.getElementById('sessions_json').value
    );

    ko.applyBindings(
      new ListingVM(sessionsData),
      document.getElementById('session_listing')
    );
  }
};

